var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "puzzle",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M18 10C16.9 10 16 10.9 16 12H12V8C10.9 8 10 7.1 10 6C10 4.9 10.9 4 12 4V0H22C23.1 0 24 0.9 24 2V12H20C20 10.9 19.1 10 18 10ZM6 14C7.1 14 8 13.1 8 12H12V16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20V24H2C0.9 24 0 23.1 0 22V12H4C4 13.1 4.9 14 6 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M10 6C10 7.1 10.9 8 12 8V12H8C8 13.1 7.1 14 6 14C4.9 14 4 13.1 4 12H0V2C0 0.9 0.9 0 2 0H12V4C10.9 4 10 4.9 10 6ZM14 18C14 16.9 13.1 16 12 16V12H16C16 10.9 16.9 10 18 10C19.1 10 20 10.9 20 12H24V22C24 23.1 23.1 24 22 24H12V20C13.1 20 14 19.1 14 18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.5c525488.svg";
export { ForwardRef as ReactComponent };